
import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { Action } from "vuex-class";
import { Prop } from "vue-property-decorator";
import { AxiosResponse } from "axios";
import toast from "@/functions/toast.function";

@Component({
  components: {
  },
  filters,
})
export default class ModalEnd extends Vue {
  @Action("actionEnd", { namespace: "partnership" })
  private actionEnd: any;

  @Prop({default: false})
  private show: boolean;
  @Prop({default: 0})
  private id: number;

  private reset() {
    this.$emit("close");
  }

  private submit() {
    this.actionEnd({
      params: {
        id: this.id
      },
      success: (response: AxiosResponse) => {
        if (response) {
          toast.success("Ended.");
          this.$emit("submit");
        }
      },
    });
  }
}
